import { useCallback, useEffect, useState } from 'react';
import Affordability from '../../images/marketing/affordability.webp';
import Expertise from '../../images/marketing/expertise.webp';
import Marketplace from '../../images/marketing/marketplace.webp';
import { CompanyTestimonials } from './company-testimonials';

export function CompanyTestimonialsBanner({}) {
  return (
    <section className="bg-hardwood-30 flex w-full flex-col items-center justify-center space-y-8 px-4 py-10 md:py-24">
      <div className="flex flex-col space-y-4 text-center md:pb-8">
        <div className="text-eyebrow">4.8 stars on trustpilot</div>
        <h2 className="text-heading-2">What homebuyers are saying</h2>
      </div>

      <div className="w-full max-w-[1200px]">
        <CompanyTestimonials />
      </div>

      <div className="pt-8">
        <a
          href="/get-started/mortgage"
          className="pointer text-button text-hardwood-30 border-hardwood-800 bg-hardwood-800 hover:bg-hardwood-600 hover:text-hardwood-30 inline-block rounded-3xl border px-6 py-3 text-center uppercase"
        >
          Get Started
        </a>
      </div>
    </section>
  );
}

export function HomebuyerNeedsBanner({}) {
  return (
    <section className="--homebuyer_needs_banner bg-hardwood-100 flex w-full flex-col items-center justify-center space-y-8 px-4 py-10 md:py-20">
      <div className="flex max-w-2xl flex-row pb-4 text-center md:pb-8">
        <h2 className="text-heading-2">
          Designed to serve your needs as a homebuyer.
        </h2>
      </div>

      <div className="flex max-w-5xl flex-col space-y-12 md:flex-row md:space-x-12 md:space-y-0">
        <div className="flex flex-col items-center justify-center space-y-4 md:w-1/3">
          <img
            className="max-h-60"
            src={Expertise}
            alt="Expertise"
            width="206"
            height="233"
          />
          <h3 className="text-heading-3 text-center">Expertise</h3>
          <p className="text-body text-center">
            Speak with a licensed mortgage broker who knows your market for
            guidance at any point in your journey.
          </p>
        </div>
        <div className="flex flex-col items-center justify-center space-y-4 md:w-1/3">
          <img
            className="max-h-60"
            src={Affordability}
            alt="Affordability"
            width="206"
            height="230"
          />
          <h3 className="text-heading-3 text-center">Affordability</h3>
          <p className="text-body text-center">
            Access services and tools that make buying a home affordable for you
            – even as rates fluctuate.
          </p>
        </div>
        <div className="flex flex-col items-center justify-center space-y-4 md:w-1/3">
          <img
            className="max-h-60"
            src={Marketplace}
            alt="Marketplace"
            width="206"
            height="240"
          />
          <h3 className="text-heading-3 text-center">Marketplace</h3>
          <p className="text-body text-center">
            Browse your home financing options and secure the right solution for
            your needs, all in one place.
          </p>
        </div>
      </div>

      <div className="py-4 text-center">
        <a
          href="/get-started/mortgage"
          className="text-underline-link text-morton-700 hover:text-morton-900 hover:cursor-pointer"
        >
          Create an account to learn more
        </a>
      </div>
    </section>
  );
}
